import type { Image, ToolMark } from './schema'
import { site } from './site'
import { tools } from './tools'

/**
 * The Home About section: the desk illustration stands on a hairline floor with the lead over its
 * space; roles with tool logos as raised keys, credentials below.
 */
export const aboutSection = {
  eyebrow: 'About',
  titleThin: "Hi, I'm",
  titleBold: `${site.name}.`,
  lede: "I'm an AI Automation and GoHighLevel Specialist, proficient in designing and developing automated workflows, AI agents, and CRM systems using n8n, Make.com, Zapier, and GoHighLevel.",
  lead: 'I help businesses streamline operations, automate repetitive tasks, and connect different platforms. My expertise also includes API integrations, webhooks, Supabase, and RAG for building more advanced AI solutions.',
  leadQuiet:
    'My goal is simple: to build reliable, efficient automation systems that save time, reduce manual work, and help businesses grow.',
  note: {
    company: 'DC Marketing Growth LLC is where I build',
    product: { label: 'Support Ticketing System', href: '/work/featured' },
    rest: 'is my featured build — a full support pipeline inside GoHighLevel, running for AA Health Insurance.',
  },
  picture: {
    src: '/images/profile/desk.webp',
    srcSet: '/images/profile/800/desk.webp 800w, /images/profile/desk.webp 1200w',
    alt: `Illustration of ${site.name} at a desk, working at a monitor with a coffee beside them`,
    width: 1200,
    height: 889,
  } satisfies Image,
}

export const capabilities: { title: string; tools: ToolMark[] }[] = [
  { title: 'Workflow Automation', tools: [tools.n8n, tools.make, tools.zapier] },
  { title: 'AI Integration', tools: [tools.openai, tools.claude, tools.gemini, tools.vapi, tools.elevenlabs] },
  { title: 'Client Systems', tools: [tools.gohighlevel, tools.asana, tools.slack, tools.airtable] },
  { title: 'Data & Documentation', tools: [tools.gohighlevel, tools.airtable, tools.slack] },
]

export type AboutCredential = {
  id: 'cert' | 'place' | 'community' | 'partner'
  title: string
  detail: string
  image?: Image
  /** A dark-theme version of the mark, when the light one would vanish on a dark ground (or the reverse). */
  imageDark?: Image
  href?: string
}

export const credentials: AboutCredential[] = [
  { id: 'cert', title: 'Information Computer Technology', detail: 'STI College Dasmariñas · 2018–2020' },
  { id: 'place', title: `Based ${site.timePlace}`, detail: 'GMT+8 · Manila, Philippines' },
  { id: 'partner', title: 'DC Marketing Growth LLC', detail: 'AI Automation Specialist · Feb 2025–Present' },
]
